import styled from 'styled-components';
import { theme } from '../../../styles/constants';

export const StyledBasicButton = styled.button`
  position: relative;
  width: 100%;
  height: 4.8rem;
  padding: ${props => (props.$isLoading ? '0 3.4rem' : '1.2rem')};
  border-radius: 16px;
  color: ${theme.colors.white};
  font-size: 1.6rem;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.42px;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    border: 1px solid rgba(132, 62, 254, 0.15);
    background: #1d0f37;
    box-shadow: none;
    font-weight: 300;
    color: #b3a2cf;
  }
`;

export const StyledButton = styled(StyledBasicButton)`
  border: 1px solid #4d2595;
  background: linear-gradient(92deg, #a486ff 0.26%, #5b16c4 99.74%);
  box-shadow: 0px 8px 12px 0px rgba(132, 62, 254, 0.28);
`;

export const StyledTransparentButton = styled(StyledBasicButton)`
  background-color: transparent;
`;

export const ButtonIconWrapper = styled.div`
  height: 4.4rem;
  display: flex;
  align-items: center;
`;

export const ButtonLoader = styled.img`
  height: 100%;
  aspect-ratio: 1 / 1;
`;
